export default {
  "validate-email_modal-title": "Verify Your Contact Details",
  "validate-email_text_loading-message": "Please wait, your email address is being verified…",
  "validate-email_text_success-message": "Validate Email Success",
  "validate-email_text_error-message": "Validate Email Error",
  "validate-email_form-label_email": "Confirm or edit your email address",
  "validate-email_form-error_email_required": "Enter your email",
  "validate-email_form-error_email_invalid-format": "Invalid Email Address Format",
  "___validate-email_action_cancel": "",
  "validate-email_action_submit": "Continue",
  "___validate-email_title_confirm-close": "",
  "___validate-email_text_confirm-close": "",
  "___validate-email_action_confirm-close_cancel": "",
  "___validate-email_action_confirm-close_confirm": "",

  // VALIDATE EMAIL ERROR MESSAGES
  "validate-email_error_default_header-title": "Email could not be verified.",
  "validate-email_error_default_header-text": "To proceed, please confirm your email address below.",
  "validate-email_error_default_email-message": "",
  "validate-email_error_default_form-message": "Email could not be verified",
  "validate-email_error_undeliverable_header-title": "Sorry we could not confirm your e-email address. ",
  "validate-email_error_undeliverable_header-text": "To proceed, please confirm your e-mail address below.",
  "validate-email_error_undeliverable_email-message": "Username or domain does not exist, or mailbox is suspended or disabled.",
  "validate-email_error_undeliverable_form-message": "Username or domain does not exist, or mailbox is suspended or disabled.",
  "validate-email_error_unreachable_header-title": "Sorry we could not confirm your email address.",
  "validate-email_error_unreachable_header-text": "To proceed, please confirm your email address below.",
  "validate-email_error_unreachable_email-message": "Email domain could not be reached or verified.",
  "validate-email_error_unreachable_form-message": "Email domain could not be reached or verified.",
  "validate-email_error_illegitimate_header-title": "Email could not be verified.",
  "validate-email_error_illegitimate_header-text": "To proceed, please confirm your email address below.",
  "validate-email_error_illegitimate_email-message": "",
  "validate-email_error_illegitimate_form-message": "Email could not be verified",
  "validate-email_error_unknown_header-title": "Email could not be verified.",
  "validate-email_error_unknown_header-text": "To proceed, please confirm your email address below.",
  "validate-email_error_unknown_email-message": "",
  "validate-email_error_unknown_form-message": "Email could not be verified.",
  "validate-email_error_disposable_header-title": "Sorry email is suspected as disposable.",
  "validate-email_error_disposable_header-text": "To proceed, please confirm your email address below.",
  "validate-email_error_disposable_email-message": "Email could not be verified.",
  "validate-email_error_disposable_form-message": "Email is suspected as disposable.",
};